module.exports = __webpack_public_path__ + "static/img/activeBg.955524a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activeBg.png
// module id = yfYe
// module chunks = 2